export default "__VITE_ASSET__BX4X6cI1__"